import { render } from "./ReactionMenu.vue?vue&type=template&id=32d49ea8&scoped=true"
import script from "./ReactionMenu.vue?vue&type=script&lang=js"
export * from "./ReactionMenu.vue?vue&type=script&lang=js"

import "./ReactionMenu.vue?vue&type=style&index=0&id=32d49ea8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d49ea8"]])

export default __exports__